import { useEffect, useState } from 'react';

import type { RefObject } from 'react';

const useCarouselScroll = (containerRef: RefObject<HTMLDivElement | null>) => {
  const [scrollDirection, setScrollDirection] = useState('right');
  const [hasFade, setHasFade] = useState(false);
  const [isOverFlow, setIsOverFlow] = useState(false);
  const [maxScrollLeft, setMaxScrollLeft] = useState(0);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || container.children.length === 0) return;

    const hasHorizontalScroll = container.scrollWidth > container.clientWidth;
    setIsOverFlow(hasHorizontalScroll);
    setHasFade(hasHorizontalScroll);
    setMaxScrollLeft(container.scrollWidth - container.clientWidth);
  }, [containerRef]);

  const handleScroll = () => {
    const container = containerRef.current;
    if (!container || container.children.length === 0) return;

    const { scrollLeft, scrollWidth, clientWidth } = container;
    const scrollPercentage = Math.ceil(
      (100 * scrollLeft) / (scrollWidth - clientWidth),
    );
    const isAtStart = scrollPercentage <= 1;
    const isAtEnd =
      scrollPercentage >= 99 || Math.ceil(scrollLeft) >= maxScrollLeft;

    if (isAtStart) {
      setScrollDirection('right');
    } else if (isAtEnd) {
      setScrollDirection('left');
      setHasFade(false);
    } else {
      setHasFade(true);
    }
  };

  const handleScrollButton = () => {
    const container = containerRef.current;
    if (!container || container.children.length === 0) return;

    const isRightDirection = scrollDirection === 'right';
    if (isRightDirection) {
      container.scrollBy({ left: container.clientWidth, behavior: 'smooth' });
    } else {
      container.scrollLeft = 0;
    }
  };

  return {
    scrollDirection,
    isOverFlow,
    hasFade,
    handleScroll,
    handleScrollButton,
  };
};

export default useCarouselScroll;
